import React, { useState, useEffect } from "react";
import {
  EmailForm,
  ShopifyBannerBox,
  ShopifyBannerContainer,
  SubTitle,
} from "./style";
import { StyledHeadingh1 } from "../../../Global/headings";
import ShopifyFormModal from "../../PPCModals/ShopifyFormModal";
import { useStaticQuery, graphql } from "gatsby";
import GravityFormForm from "../../../GravityForm";
import { GlobalContainer } from "../../../Global/layout";

const ShopifyBanner = ({ data, emailValue, setEmailValue }: any) => {
  const ShopifyEmailData = useStaticQuery(graphql`
    query HiringShopifyProcess {
      tsGfForm(databaseId: { eq: 12 }) {
        ...GravityFormFields
      }
      ts {
        gfSettings {
          recaptcha {
            publicKey
            type
          }
        }
      }
    }
  `);

  var formvalue: string | null | undefined;
  function getFormValues(value: object) {
    formvalue = value.input_2;
  }

  const [open, setOpen] = useState(false);

  const onSuccess = () => {
    setOpen(true);
    setEmailValue(formvalue);
  };

  useEffect(() => {
    if (open) {
      document.body.classList.add("fullscreen-model");
    } else {
      document.body.classList.remove("fullscreen-model");
    }
  }, [open]);

  return (
    <section className="light">
      <ShopifyBannerBox>
        <ShopifyBannerContainer>
          <StyledHeadingh1
            style={{ textAlign: "center" }}
            text={data.heading}
          />
          <GlobalContainer>
            <SubTitle
              data-aos="fade-up"
              dangerouslySetInnerHTML={{ __html: data.content }}
            />
          </GlobalContainer>

          <EmailForm data-aos="fade-up">
            <div className="hire_email_form">
              <GravityFormForm
                data={ShopifyEmailData}
                successCallback={onSuccess}
                getFormValues={getFormValues}
              />
            </div>
          </EmailForm>
        </ShopifyBannerContainer>
      </ShopifyBannerBox>

      <ShopifyFormModal
        openShopifyFormModal={open}
        emailValue={emailValue}
        buttonText={data?.cta?.title}
      />
    </section>
  );
};

export default ShopifyBanner;
